  import React, { useState } from "react";
import QuantityDiscountCards from "./QuantityDiscountCards";
import { savePendingCouponSel, clearPendingCouponSel } from "../utils/purchaseOptions";
import "../styles/PurchaseOptions.css";
import "../styles/productdetail.css";

const typeToPurchaseMap = {
  piece: "piece",
  pack: "pack",
  cart: "carton",
  extra1: "extra1",
  extra2: "extra2",
  extra3: "extra3",
};

const PurchaseOptionsModal = ({ isOpen, onClose, onConfirm, product }) => {
  const [tempSelectedType, setTempSelectedType] = useState(null);
  const [tempSelectedCoupon, setTempSelectedCoupon] = useState(null);

  if (!isOpen) return null;

  const hasDiscounts = product?.discount_items?.length > 0;
  if (!hasDiscounts) return null;

  const pid = product?.productid || product?.id;

  const handleCouponSelect = (coupon) => {
    if (!coupon) {
      setTempSelectedCoupon(null);
      setTempSelectedType(null);
      return;
    }
    const mappedType = typeToPurchaseMap[coupon.type] || "piece";
    setTempSelectedCoupon(coupon);
    setTempSelectedType(mappedType);
  };

  const handleClose = () => {
    clearPendingCouponSel(pid);
    onClose();
  };

  const handleConfirm = () => {
    if (tempSelectedCoupon) {
      savePendingCouponSel(pid, tempSelectedType || "piece", tempSelectedCoupon);
    }
    onConfirm(tempSelectedType || "piece", tempSelectedCoupon);
  };

  return (
    <div className="purchase-modal-backdrop" role="presentation">
      <div
        className="purchase-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="purchase-modal-title"
      >
        <h3 id="purchase-modal-title">Quantity Discount Offers</h3>

        <QuantityDiscountCards
          product={product}
          selectedCoupon={tempSelectedCoupon}
          onSelect={handleCouponSelect}
          disableOthersOnSelect={false}
        />

        <div className="purchase-modal-actions">
          <button type="button" className="purchase-cancel-btn" onClick={handleClose}>
            Cancel
          </button>
          <button
            type="button"
            className="purchase-confirm-btn"
            onClick={handleConfirm}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOptionsModal;
